import { Record } from 'immutable';
import { schema } from 'normalizr';

export const AnnualSolarReport = new Record({
  id: undefined,
  consumed: undefined,
  generated: undefined,
  corrected: undefined,
  year_end_date: undefined,
  site: undefined,
});

export const annualSolarReportSchema = new schema.Entity('annualSolarReports');

// for reading in nested models, object with { field: schema }
// annualSolarReportSchema.define({  });
